<div style="padding: 10px !important;  width:100% !important; background-color: white" class="box-padrao-table">
  <h4 style="padding-top: 15px; font-size: 20px; font-weight: 500; color: #434a54;">Acompanhamento</h4>

  <mat-accordion>
    <mat-expansion-panel class="expansion-panel" [expanded]="step === 0" (opened)="setStep(0)">

      <mat-expansion-panel-header class="custom-header">
        <mat-panel-title>
          <mat-icon>search</mat-icon> Pesquisar protocolos
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-progress-bar *ngIf="loadAcompanhamento" class="progress-bar" mode="indeterminate"></mat-progress-bar>

      <!-- Primeira linha de filtros: Nº Protocolo, Documento, Fornecedor, Nº do Pedido -->
      <form [formGroup]="pesquisaForm">
        <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
          <mat-form-field fxFlex="17%">
            <input matInput onlyNumbers formControlName="frmNProtocolo" [(ngModel)]="pesquisaProtocolos.idProtocolo" placeholder="N° Protocolo">
          </mat-form-field>
          <mat-form-field fxFlex="17%">
            <input matInput onlyNumbers formControlName="frmDocumento" [(ngModel)]="pesquisaProtocolos.documentoId" placeholder="Documento">
          </mat-form-field>
          <mat-form-field fxFlex="17%">
            <input matInput formControlName="frmCnpjFornecedor" [(ngModel)]="pesquisaProtocolos.cnpjFornecedor" (input)="sanitizarCNPJFornecedorFiltroInput($event)" placeholder="CNPJ/CPF/CÓDIGO DO FORNECEDOR" maxlength="20">
          </mat-form-field>
          <mat-form-field fxFlex="32%">
            <input matInput formControlName="frmNomeFornecedor" [(ngModel)]="pesquisaProtocolos.nomeFornecedor" placeholder="Nome Fornecedor">
          </mat-form-field>
          <mat-form-field fxFlex="17%">
            <input matInput onlyNumbers formControlName="frmNPedido" [(ngModel)]="pesquisaProtocolos.idPedido" placeholder="N° Pedido">
          </mat-form-field>
        </div>

        <!-- Segunda Linha de Filtros: Datas Inicio e Emissão-->
        <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
          <!-- Dt. Criação Início -->
          <mat-form-field fxFlex="25%">
            <input matInput formControlName="frmCriacaoInicio" [matDatepickerFilter]="filterData" [matDatepicker]="picker1" (change)="validarDataCriacaoInicio($event)" (dateChange)="validarDataCriacaoInicio($event)" [(ngModel)]="pesquisaProtocolos.criacaoInicio"
              placeholder="Dt. Criação Início" #inputDataCriacaoInicio>
            <span matSuffix class="calendar">
              <mat-icon (click)="picker1.open()">calendar_today</mat-icon>
            </span>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
          <!-- Dt. Criação Fim -->
          <mat-form-field fxFlex="25%">
            <input matInput formControlName="frmCriacaoFim" [matDatepickerFilter]="filterData" [matDatepicker]="picker2" (change)="validarDataCriacaoFim($event)" (dateChange)="validarDataCriacaoFim($event)" [(ngModel)]="pesquisaProtocolos.criacaoFim" placeholder="Dt. Criação Fim"
              #inputDataCriacaoFim>
            <span matSuffix class="calendar">
              <mat-icon (click)="picker2.open()">calendar_today</mat-icon>
            </span>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
          <!-- Dt. Emissão Início -->
          <mat-form-field fxFlex="25%">
            <input matInput formControlName="frmEmissaoInicio" [matDatepickerFilter]="filterData" [matDatepicker]="picker3" (change)="validarDataEmissaoInicio($event)" (dateChange)="validarDataEmissaoInicio($event)" [(ngModel)]="pesquisaProtocolos.emissaoInicio"
              placeholder="Dt. Emissão Início" #inputDataEmissaoInicio>
            <span matSuffix class="calendar">
              <mat-icon (click)="picker3.open()">calendar_today</mat-icon>
            </span>
            <mat-datepicker #picker3></mat-datepicker>
          </mat-form-field>
          <!-- Dt. Emissão Fim -->
          <mat-form-field fxFlex="25%">
            <input matInput formControlName="frmEmissaoFim" [matDatepickerFilter]="filterData" [matDatepicker]="picker4" (change)="validarDataEmissaoFim($event)" (dateChange)="validarDataEmissaoFim($event)" [(ngModel)]="pesquisaProtocolos.emissaoFim" placeholder="Dt. Emissão Fim"
              #inputDataEmissaoFim>
            <span matSuffix class="calendar">
              <mat-icon (click)="picker4.open()">calendar_today</mat-icon>
            </span>
            <mat-datepicker #picker4></mat-datepicker>
          </mat-form-field>
        </div>

        <!-- Terceira Linha de Filtros: Datas Vencimento e Conclusão -->
        <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
          <!-- Dt. Vencimento Início -->
          <mat-form-field fxFlex="25%">
            <input matInput formControlName="frmVencimentoInicio" [matDatepickerFilter]="filterData" [matDatepicker]="picker5" (change)="validarDataVencimentoInicio($event)" (dateChange)="validarDataVencimentoInicio($event)" [(ngModel)]="pesquisaProtocolos.vencimentoInicio"
              placeholder="Dt. Vencimento Início" #inputDataVencimentoInicio>
            <span matSuffix class="calendar">
              <mat-icon (click)="picker5.open()">calendar_today</mat-icon>
            </span>
            <mat-datepicker #picker5></mat-datepicker>
          </mat-form-field>
          <!-- Dt. Vencimento Fim -->
          <mat-form-field fxFlex="25%">
            <input matInput formControlName="frmVencimentoFim" [matDatepickerFilter]="filterData" [matDatepicker]="picker6" (change)="validarDataVencimentoFim($event)" (dateChange)="validarDataVencimentoFim($event)" [(ngModel)]="pesquisaProtocolos.vencimentoFim"
              placeholder="Dt. Vencimento Fim" #inputDataVencimentoFim>
            <span matSuffix class="calendar">
              <mat-icon (click)="picker6.open()">calendar_today</mat-icon>
            </span>
            <mat-datepicker #picker6></mat-datepicker>
          </mat-form-field>
          <!-- Dt. Conclusão Início -->
          <mat-form-field fxFlex="25%">
            <input matInput formControlName="frmConclusaoInicio" [matDatepickerFilter]="filterData" [matDatepicker]="picker7" (change)="validarDataConclusaoInicio($event)" (dateChange)="validarDataConclusaoInicio($event)" [(ngModel)]="pesquisaProtocolos.conclusaoInicio"
              placeholder="Dt. Conclusão Início" #inputDataConclusaoInicio>
            <span matSuffix class="calendar">
              <mat-icon (click)="picker7.open()">calendar_today</mat-icon>
            </span>
            <mat-datepicker #picker7></mat-datepicker>
          </mat-form-field>
          <!-- Dt. Conclusão Fim -->
          <mat-form-field fxFlex="25%">
            <input matInput formControlName="frmConclusaoFim" [matDatepickerFilter]="filterData" [matDatepicker]="picker8" (change)="validarDataConclusaoFim($event)" (dateChange)="validarDataConclusaoFim($event)" [(ngModel)]="pesquisaProtocolos.conclusaoFim" placeholder="Dt. Conclusão Fim"
              #inputDataConclusaoFim>
            <span matSuffix class="calendar">
              <mat-icon (click)="picker8.open()">calendar_today</mat-icon>
            </span>
            <mat-datepicker #picker8></mat-datepicker>
          </mat-form-field>
        </div>

        <!-- Quarta Linha de Filtros: Usuários (Aprovador, Criação, Responsável, Filtros Personalizado ) -->
        <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
          <!-- Usuário Aprovador -->
          <mat-form-field fxFlex="25%">
            <mat-select formControlName="frmUsuarioAprovador" [(ngModel)]="pesquisaProtocolos.loginAprovador" placeholder="Usuário Aprovador">
              <mat-option>Selecione</mat-option>
              <mat-option *ngFor="let aprovador of aprovadoresSLD" [value]="aprovador.login">
                {{aprovador.nome}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <!-- Usuário Criação -->
          <mat-form-field fxFlex="25%">
            <mat-select formControlName="frmUsuarioCriacao" [(ngModel)]="pesquisaProtocolos.loginUsuarioCriacao" placeholder="Usuário Criação">
              <mat-option>Selecione</mat-option>
              <mat-option *ngFor="let usuario of usuarios" [value]="usuario.login">
                {{usuario.nome}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <!-- Responsável -->
          <mat-form-field fxFlex="25%">
            <mat-select formControlName="frmResponsavel" [(ngModel)]="pesquisaProtocolos.loginResponsavel" placeholder="Responsável">
              <mat-option>Selecione</mat-option>
              <mat-option *ngFor="let responsavel of responsaveis" [value]="responsavel.login">
                {{responsavel.nome}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <!-- Meus Filtros -->
          <mat-form-field fxFlex="20%">
            <mat-select formControlName="frmMeusFiltros" [(ngModel)]="pesquisaProtocolos.idFiltro" placeholder="Meus Filtros">
              <mat-option>Selecione</mat-option>
              <mat-option *ngFor="let item of lstFiltro" [value]="item.idFiltro">
                {{item.nomeFiltro}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div fxFlex="5%">
            <a class="linkFiltro" mat-mini-fab (click)="filtroPesquisa()">
              <mat-icon class="iconFiltro">add</mat-icon>
            </a>
          </div>
        </div>

        <!-- Quinta Linha de Filtros: Outros - Valor , Tipo Protocolo com seus dependentes e Status -->
        <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
          <!-- Status -->
          <mat-form-field fxFlex="24.4%">
            <mat-select formControlName="frmStatusProtocolo" [(ngModel)]="pesquisaProtocolos.statusProtocolo" placeholder="Status">
              <mat-option>Selecione</mat-option>
              <mat-option *ngFor="let status of statusProtocolos" [value]="status.idStatus">
                {{status.descricao}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <!-- Valor -->
          <mat-form-field fxFlex="15%">
            <input matInput formControlName="frmValor" [(ngModel)]="pesquisaProtocolos.valor" placeholder="Valor" class="example-right-align" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
          </mat-form-field>
          <!-- Selecione o tipo de protocolo -->
          <mat-form-field fxFlex="20%">
            <mat-select formControlName="frmTipoProtocolo" [(ngModel)]="pesquisaProtocolos.tipoProtocolo" placeholder="Selecione o tipo de protocolo" (selectionChange)="carregarTipoDoc()">
              <mat-option value="2">Fiscal</mat-option>
              <mat-option value="1">Não Fiscal</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field fxFlex="30%">
            <mat-select formControlName="frmTipoDoc" [(ngModel)]="pesquisaProtocolos.idTipoDocumento" placeholder="{{placeholderTipoDocumento}}">
              <mat-option>Selecione</mat-option>
              <mat-option *ngFor="let tipoDoc of tipoDocs" [value]="tipoDoc.codTipoDocumento">
                {{tipoDoc.tipoDocumento}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <mat-action-row class="footer">
          <button mat-button type="button" color="warn" (click)="limparFiltro()">Limpar Filtros </button>
          <button mat-button type="button" color="primary" class="btn-primary" (click)="onCarregarLista()">PESQUISAR</button>
        </mat-action-row>
      </form>
    </mat-expansion-panel>
  </mat-accordion>

  <div style="padding-left: 80%">
    <mat-form-field style="width:100%">
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrar">
    </mat-form-field>
  </div>
  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort style="width:100%;">
      <ng-container matColumnDef="naoFiscal">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> naoFiscal </th>
        <td mat-cell *matCellDef="let element"> Não Fiscal </td>
      </ng-container>

      <ng-container matColumnDef="idProtocolo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Protocolo </th>
        <td mat-cell *matCellDef="let element"> {{element.idProtocolo}} </td>
      </ng-container>

      <ng-container matColumnDef="numNota">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> N° da Nota </th>
        <td mat-cell *matCellDef="let element" style="text-align: center"> - </td>
      </ng-container>

      <ng-container matColumnDef="documento">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Documento </th>
        <td mat-cell *matCellDef="let element"> {{element.documento}} </td>
      </ng-container>

      <ng-container matColumnDef="valor">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Valor </th>
        <td mat-cell *matCellDef="let element">{{element.valor | currency:'BRL':true:'1.2-4'}} </td>
      </ng-container>

      <ng-container matColumnDef="dataEmissaoNf">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Data Criação </th>
        <td mat-cell *matCellDef="let element"> {{element.dataHoraCriacaoExibicao}} </td>
      </ng-container>

      <ng-container matColumnDef="dataVencimentoNf">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Data Vencimento </th>
        <td mat-cell *matCellDef="let element"> {{element.dataVencimentoNfExibicao}} </td>
      </ng-container>

      <ng-container matColumnDef="nomeFornecedor">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fornecedor </th>
        <td mat-cell *matCellDef="let element"> {{element.nomeFornecedor}} </td>
      </ng-container>

      <ng-container matColumnDef="loginResponsavel">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Responsável </th>
        <td mat-cell *matCellDef="let element"> {{element.loginResponsavel}} </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
        <td mat-cell *matCellDef="let element"> {{element.status}} </td>
      </ng-container>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let element">
          <a mat-button *ngIf="element.naoFiscal === 1" [routerLink]="['/protocolo-naofiscal', element.idProtocolo]" (click)="NavigateProtocolo(element.documento)" color="orange" target="_blank">
            <mat-icon>edit</mat-icon>
          </a>
          <a mat-button *ngIf="element.naoFiscal !== 1" [routerLink]="['/protocolo-fiscal', element.idProtocolo]" (click)="NavigateProtocolo(element.documento)" color="orange" target="_blank">
            <mat-icon>edit</mat-icon>
          </a>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator [pageSizeOptions]="[5, 50, 100, 500, 1000]" showFirstLastButtons></mat-paginator>
</div>
